export default __webpack_public_path__ + "static/media/Dis_PrintWHT.bccb2ded.svg";